<template>
  <el-drawer
  :title="$t('invoices.filters.filters')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form>
      <el-form-item>
        <el-button @click="resetFilters()" size="mini">{{$t('invoices.filters.reset')}}</el-button>
      </el-form-item>
      <el-collapse v-model="activeName">
        <el-collapse-item :title="$t('invoices.filters.status')" name="1">
          <el-form-item>
            <el-checkbox-group v-model="statusFilter">
              <el-row :gutter="20" v-for="status in invoiceStatuses" :key="status.id">
                <el-col>
                  <el-checkbox :label="status.id">{{$t('invoices.statuses.'+status.code)}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
         </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="Date" name="2">
          <el-form-item :label="$t('invoices.filters.billingDate')">
            <el-date-picker
               v-model="dateFilter"
               type="daterange"
               range-separator="à"
               start-placeholder="Date de début"
               end-placeholder="Date de fin">
             </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('invoices.filters.paidAt')">
            <el-date-picker
               v-model="paidAtFilter"
               type="daterange"
               range-separator="à"
               start-placeholder="Date de début"
               end-placeholder="Date de fin">
             </el-date-picker>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('invoices.filters.invoiceNotice')" name="3">
          <el-form-item >
            <el-checkbox-group v-model="invoicedFilter">
              <el-row :gutter="20" v-for="status in invoiceNoticeStatuses" :key="status.id">
                <el-col>
                  <el-checkbox :label="status.id">{{$t('invoices.notice_statuses.'+status.code)}}</el-checkbox>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col>
                  <el-checkbox label="NOT_SENT">{{$t('invoices.filters.notSent')}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('invoices.filters.rep')" name="4">
          <el-form-item>
            <el-checkbox-group  v-model="checkedReps" :disabled="repFilterDisabled">
              <el-row v-for="rep in filterUserWithRoleRep" :key="rep.id" >
                <el-col>
                  <el-checkbox :label="rep.id" style="margin-left:0px;">{{rep.firstName}} {{rep.lastName}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
            <el-checkbox v-model="withoutReps" :disabled="repFilterDisabled">{{$t('invoices.filters.notRepresented')}}</el-checkbox>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('invoices.filters.customer')" name="5">
          <el-form-item >
            <selectCustomer :selectedCustomer="filters.customerId" @selected="setCustomerFilter"></selectCustomer>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('invoices.filters.product')" name="6">
          <el-form-item >
            <selectProduct :selectedProduct="filters.productId" @selected="setProductFilter"></selectProduct>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('invoices.filters.customerclass')" name="7">
          <el-form-item>
            <el-checkbox-group  v-model="checkedCustomerClasses" >
              <el-row :gutter="20" v-for="cclass in customerClasses" :key="cclass.id">
                <el-col>
                  <el-checkbox  :label="cclass.id"  style="margin-left:0px;">{{cclass.code}}</el-checkbox>
                </el-col>
              </el-row>
            </el-checkbox-group>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import selectCustomer from '@/components/customer/select-customer'
import selectProduct from '@/components/product/select-product'

export default {
  name: 'invoice-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : null,
    };
  },components: {
    selectCustomer,
    selectProduct
  },
  watch : {

  },
	methods: {
    open(){
      this.fetchCustomerClasses();
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('statuses',['fetchInvoiceStatuses','fetchInvoiceNoticeStatuses']),
    ...mapActions('invoices', ['setStatusFilters','resetFilters','setDateFilters','setPaidAtFilters','changeCustomerClassFilter','changeInvoicedFilter','setCheckedReps','setFilterWithoutReps','setCustomerFilter','setProductFilter']),
    ...mapActions('controlData',['fetchCustomerClasses']),
    ...mapActions('users',['fetchAdminUsers'])
	},
	computed: {
    repFilterDisabled(){
      return this.isStrictFilteredByRep && this.isCurrentUserRep && !this.isCurrentUserAdmin;
    },
    withoutReps : {
      set(val){this.setFilterWithoutReps(val)},
      get(){return this.filters.withoutReps}
    },
    checkedReps : {
			set(val){this.setCheckedReps(val)},
			get(){return this.filters.checkedReps}
		},
    statusFilter : {
      get(){return this.filters.status;},
      set(statusFilters){this.setStatusFilters(statusFilters)}
    },
    dateFilter : {
      get(){return this.filters.date},
      set(dateFilter){this.setDateFilters(dateFilter)}
    },
    paidAtFilter : {
      get(){return this.filters.paidAt},
      set(paidAtFilter){this.setPaidAtFilters(paidAtFilter)}
    },
		checkedCustomerClasses :{
			set(val){this.changeCustomerClassFilter(val)},
			get(){return this.filters.checkedCustomerClasses;}
		},
    invoicedFilter : {
      set(val){this.changeInvoicedFilter(val)},
      get(){return this.filters.checkedInvoiced;}
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "40%";
      }else{
        return "100%"
      }
    },
    ...mapState('statuses',['invoiceStatuses','invoiceNoticeStatuses']),
    ...mapState('invoices',['filters']),
    ...mapState('controlData',['customerClasses']),
    ...mapGetters('users',['filterUserWithRoleRep']),
    ...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep', 'isCurrentUserAdmin']),
	},
  created(){
    this.fetchInvoiceStatuses();
    this.fetchInvoiceNoticeStatuses();
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
